// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.speechbot-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.speechbot-play-stop-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.speechbot-play-stop-button {
  position: relative;
  width: 60px;
  height: 60px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(115, 115, 118);
}

.speechbot-play-stop-button:hover:not(:disabled) {
  opacity: 0.8;
}

.speechbot-play-stop-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.speechbot-button-inner {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.speechbot-icon-container {
  width: 20px;
  height: 20px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.speechbot-play-icon,
.speechbot-stop-icon {
  width: 100%;
  height: 100%;
}

.speechbot-ripple-effect {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  transform: translate(-50%, -50%) scale(0);
  background: rgba(255, 255, 255, 0.2);
  pointer-events: none;
  transition: transform 0.3s ease-out;
}

.speechbot-play-stop-button.speechbot-inactive {
  background-color: rgb(115, 115, 118);
}

.speechbot-play-stop-button.speechbot-listening {
  background-color: #4CAF50;
}

.speechbot-play-stop-button.speechbot-ai-speaking {
  background-color: #2196F3;
}

.speechbot-play-stop-button.speechbot-streaming {
  background-color: #9C27B0;
}

.speechbot-play-stop-button.speechbot-error {
  background-color: #f44336;
  cursor: not-allowed;
}

.speechbot-status-text {
  font-family: Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: normal;
  color: rgb(115, 115, 118);
  text-align: center;
  transition: all 0.2s ease;
}

.speechbot-status-text.speechbot-listening {
  color: #4CAF50;
}

.speechbot-status-text.speechbot-ai-speaking {
  color: #2196F3;
}

.speechbot-status-text.speechbot-streaming {
  color: #9C27B0;
}

.speechbot-status-text.speechbot-error {
  color: #f44336;
}

.speechbot-play-stop-button:active:not(:disabled) .speechbot-ripple-effect {
  transform: translate(-50%, -50%) scale(1);
}

.speechbot-play-stop-button:active:not(:disabled) .speechbot-icon-container {
  transform: scale(0.95);
}

.speechbot-error-tooltip {
  position: relative;
  display: inline-block;
}

.speechbot-error-tooltip .speechbot-tooltip-text {
  visibility: hidden;
  width: 200px;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 8px 12px;
  position: absolute;
  z-index: 1000;
  bottom: 125%;
  left: 50%;
  margin-left: -100px;
  font-size: 14px;
  font-weight: normal;
  opacity: 0;
  transition: opacity 0.3s;
}

.speechbot-error-tooltip .speechbot-tooltip-text::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #333 transparent transparent transparent;
}

.speechbot-error-tooltip:hover .speechbot-tooltip-text {
  visibility: visible;
  opacity: 1;
}

.speechbot-exclamation-icon {
  font-size: 16px;
  color: white;
  font-weight: bold;
}

.speechbot-audio-indicator {
  position: absolute;
  bottom: -40px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 3px;
  align-items: end;
}

.speechbot-wave {
  width: 3px;
  background: rgb(115, 115, 118);
  border-radius: 2px;
  animation: speechbot-wave-animation 1.2s infinite ease-in-out;
}

.speechbot-wave-1 {
  height: 10px;
  animation-delay: 0s;
}

.speechbot-wave-2 {
  height: 16px;
  animation-delay: 0.2s;
}

.speechbot-wave-3 {
  height: 13px;
  animation-delay: 0.4s;
}

@keyframes speechbot-wave-animation {
  0%, 100% {
    transform: scaleY(0.5);
    opacity: 0.7;
  }
  50% {
    transform: scaleY(1);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./dist/src/components/controls/speech-bot/SpeechBot.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,oCAAoC;EACpC,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,8BAA8B;EAC9B,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,oBAAoB;IACpB,UAAU;EACZ;AACF","sourcesContent":["\r\n.speechbot-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n}\r\n\r\n.speechbot-play-stop-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 15px;\r\n}\r\n\r\n.speechbot-play-stop-button {\r\n  position: relative;\r\n  width: 60px;\r\n  height: 60px;\r\n  border: none;\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  outline: none;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: rgb(115, 115, 118);\r\n}\r\n\r\n.speechbot-play-stop-button:hover:not(:disabled) {\r\n  opacity: 0.8;\r\n}\r\n\r\n.speechbot-play-stop-button:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.5;\r\n}\r\n\r\n.speechbot-button-inner {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n}\r\n\r\n.speechbot-icon-container {\r\n  width: 20px;\r\n  height: 20px;\r\n  color: white;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.speechbot-play-icon,\r\n.speechbot-stop-icon {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.speechbot-ripple-effect {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 50%;\r\n  transform: translate(-50%, -50%) scale(0);\r\n  background: rgba(255, 255, 255, 0.2);\r\n  pointer-events: none;\r\n  transition: transform 0.3s ease-out;\r\n}\r\n\r\n.speechbot-play-stop-button.speechbot-inactive {\r\n  background-color: rgb(115, 115, 118);\r\n}\r\n\r\n.speechbot-play-stop-button.speechbot-listening {\r\n  background-color: #4CAF50;\r\n}\r\n\r\n.speechbot-play-stop-button.speechbot-ai-speaking {\r\n  background-color: #2196F3;\r\n}\r\n\r\n.speechbot-play-stop-button.speechbot-streaming {\r\n  background-color: #9C27B0;\r\n}\r\n\r\n.speechbot-play-stop-button.speechbot-error {\r\n  background-color: #f44336;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.speechbot-status-text {\r\n  font-family: Helvetica, Arial, sans-serif;\r\n  font-size: 14px;\r\n  font-weight: normal;\r\n  color: rgb(115, 115, 118);\r\n  text-align: center;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.speechbot-status-text.speechbot-listening {\r\n  color: #4CAF50;\r\n}\r\n\r\n.speechbot-status-text.speechbot-ai-speaking {\r\n  color: #2196F3;\r\n}\r\n\r\n.speechbot-status-text.speechbot-streaming {\r\n  color: #9C27B0;\r\n}\r\n\r\n.speechbot-status-text.speechbot-error {\r\n  color: #f44336;\r\n}\r\n\r\n.speechbot-play-stop-button:active:not(:disabled) .speechbot-ripple-effect {\r\n  transform: translate(-50%, -50%) scale(1);\r\n}\r\n\r\n.speechbot-play-stop-button:active:not(:disabled) .speechbot-icon-container {\r\n  transform: scale(0.95);\r\n}\r\n\r\n.speechbot-error-tooltip {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.speechbot-error-tooltip .speechbot-tooltip-text {\r\n  visibility: hidden;\r\n  width: 200px;\r\n  background-color: #333;\r\n  color: #fff;\r\n  text-align: center;\r\n  border-radius: 6px;\r\n  padding: 8px 12px;\r\n  position: absolute;\r\n  z-index: 1000;\r\n  bottom: 125%;\r\n  left: 50%;\r\n  margin-left: -100px;\r\n  font-size: 14px;\r\n  font-weight: normal;\r\n  opacity: 0;\r\n  transition: opacity 0.3s;\r\n}\r\n\r\n.speechbot-error-tooltip .speechbot-tooltip-text::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 50%;\r\n  margin-left: -5px;\r\n  border-width: 5px;\r\n  border-style: solid;\r\n  border-color: #333 transparent transparent transparent;\r\n}\r\n\r\n.speechbot-error-tooltip:hover .speechbot-tooltip-text {\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n\r\n.speechbot-exclamation-icon {\r\n  font-size: 16px;\r\n  color: white;\r\n  font-weight: bold;\r\n}\r\n\r\n.speechbot-audio-indicator {\r\n  position: absolute;\r\n  bottom: -40px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  display: flex;\r\n  gap: 3px;\r\n  align-items: end;\r\n}\r\n\r\n.speechbot-wave {\r\n  width: 3px;\r\n  background: rgb(115, 115, 118);\r\n  border-radius: 2px;\r\n  animation: speechbot-wave-animation 1.2s infinite ease-in-out;\r\n}\r\n\r\n.speechbot-wave-1 {\r\n  height: 10px;\r\n  animation-delay: 0s;\r\n}\r\n\r\n.speechbot-wave-2 {\r\n  height: 16px;\r\n  animation-delay: 0.2s;\r\n}\r\n\r\n.speechbot-wave-3 {\r\n  height: 13px;\r\n  animation-delay: 0.4s;\r\n}\r\n\r\n@keyframes speechbot-wave-animation {\r\n  0%, 100% {\r\n    transform: scaleY(0.5);\r\n    opacity: 0.7;\r\n  }\r\n  50% {\r\n    transform: scaleY(1);\r\n    opacity: 1;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
